import { z } from "zod";

import { machineSchema } from "./machine";

export const zebraMachineSchema = machineSchema.extend({
	isPeelOff: z.boolean().optional(),
	isPriorityPrinter: z.boolean().optional(),
	ioTHubName: z.string().optional().nullable(),
});

export type ZebraMachine = z.infer<typeof zebraMachineSchema>;
